import { SxProps, Theme } from "@mui/material";

export const appBarSx: SxProps<Theme> = {
  backgroundColor: "#fff",
  color: "#000",
  borderBottom: "1px solid #e0e0e0",
};

export const toolbarSx: SxProps<Theme> = {
  justifyContent: "space-between",
  gap: 1,
};

export const searchFieldSx: SxProps<Theme> = {
  width: 300,
  borderRadius: 3,
  "& .MuiOutlinedInput-root": {
    borderRadius: 3,
  },
};

export const userNameTypographySx: SxProps<Theme> = {
  color: "#113F67",
  fontWeight: "500",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
};

export const avatarSx: SxProps<Theme> = {
  cursor: "pointer",
  width: 50,
  height: 50,
  border: "1px solid #d1d1d1",
};

export const userBoxSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 2,
};

export const avatarBoxSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  cursor: "pointer",
};

export const roleBadgeSx = (borderColor: string): SxProps<Theme> => ({
  px: 1,
  py: 0.3,
  fontSize: "0.7rem",
  fontWeight: 600,
  borderRadius: "8px",
  color: "#fff",
  textTransform: "uppercase",
  userSelect: "none",
  display: "inline-block",
  whiteSpace: "nowrap",
  backgroundColor: borderColor,
});

export const avatarBorderBoxSx = (borderColor: string): SxProps<Theme> => ({
  borderRadius: "50%",
  p: 0,
  display: "inline-block",
  border: `2px solid ${borderColor}`,
  transition: "border-color 0.3s ease",
  cursor: "pointer",
  "&:hover": {
    borderColor: "#1976d2",
  },
});
